import { useParams } from "react-router-dom";
import NewRequest from "./NewRequest";
import NewRequest13 from "./NewRequest13";
import NewRequest14 from "./NewRequest14";

const clientRequestPages = {
    11: NewRequest,
    13: NewRequest13,
    14: NewRequest14,
};

const NewRequestRouter = () => {
    const { clientId } = useParams();
    const PageComponent = clientRequestPages[clientId] || NewRequest;
    return <PageComponent />;
};

export default NewRequestRouter;
